import React from "react";
import "./TeamOperators.css";
import davidImg from "../../../images/david.png";
import davidMobileImg from "../../../images/mobile.png";
import clydeImg from "../../../images/clyde.png";
import clydeMobileImg from "../../../images/clyde-mb.png";

const TeamOperators = () => {
  return (
    <section className="team-operators-section mt-4">
      <div className="container">
        <div className="team-operators-panel">
          <div className="team-operator team-operator-left">
            <div className="team-operator-photo">
              <img
                src={davidImg}
                alt="David Mantica"
                className="team-operator-image team-operator-image-desktop"
              />
              <img
                src={davidMobileImg}
                alt="David Mantica"
                className="team-operator-image team-operator-image-mobile"
              />
            </div>

            <div className="team-operator-copy-card">
              <h3 className="team-operator-name">David Mantica</h3>
              <p className="team-operator-copy">
                20+ years building technical training and workforce companies. David understands how to build product-market fit, scale B2B and B2C revenue, and turn workforce solutions into recurring revenue engines. 
              </p>
            </div>
          </div>

          <div className="team-operator team-operator-right">
            <div className="team-operator-copy-card">
              <h3 className="team-operator-name">Clyde Seepersad</h3>
              <p className="team-operator-copy">
                Clyde brings strategic clarity and operational rigor to
                high-growth environments. He strengthens top-line growth, unit
                economics, and scalable operating models.
              </p>
            </div>

            <div className="team-operator-photo">
              <img
                src={clydeImg}
                alt="Clyde Seepersad"
                className="team-operator-image team-operator-image-desktop"
              />
              <img
                src={clydeMobileImg}
                alt="Clyde Seepersad"
                className="team-operator-image team-operator-image-mobile"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamOperators;